import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOffline } from '../Context/OfflineContext';
import { Auth } from '../utils/auth';
import Router from '../router';

export const ConnectivityHandler = () => {
  const { connectionStatus } = useOffline();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const auth = new Auth();
    const isAuth = auth.isAuthenticated();
    
    // Si se pierde la conexión y el usuario está autenticado
    if (connectionStatus === false && isAuth) {
      const offlinePath = Router.appOfflineWorkflow.replace(':id', '1075');
      
      const isAlreadyOffline = location.pathname.includes('/offline/');
      const isLoginPage = location.pathname === Router.appLogin;
      const isMaintenancePage = location.pathname === Router.appMaintenance;

      if (!isLoginPage && !isAlreadyOffline && !isMaintenancePage) {
        navigate(offlinePath, { replace: true });
      }

    } else if (connectionStatus === true && location.pathname.includes('/offline/')) {
      // Si recuperamos la conexión y estamos en offline, volver a online
      const onlinePath = Router.appWorkflow.replace(':id', '1075');
      
      navigate(onlinePath, { replace: true });
    }
  }, [connectionStatus, navigate, location]);

  return null;
};
